var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoverWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49213 17.6405C4.63859 17.6405 0.689968 13.6837 0.689968 8.82006C0.689968 3.95645 4.63859 0 9.49213 0C14.3457 0 18.2943 3.9568 18.2943 8.82041C18.2943 13.684 14.3457 17.6408 9.49213 17.6408V17.6405ZM9.49213 3.67065C6.65851 3.67065 4.35302 5.98091 4.35302 8.82041C4.35302 11.6599 6.65851 13.9702 9.49213 13.9702C12.3258 13.9702 14.6312 11.6599 14.6312 8.82041C14.6312 5.98091 12.3258 3.67065 9.49213 3.67065Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44145 24C5.88081 24 2.52779 22.6162 0 20.1034L2.57952 17.4976C4.41664 19.3238 6.85355 20.3294 9.44145 20.3294C12.0294 20.3294 14.5418 19.2933 16.3887 17.4118L19 19.9858C16.4593 22.5741 13.0643 24 9.44145 24Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49214 10.9223C10.6506 10.9223 11.5897 9.98124 11.5897 8.82041C11.5897 7.65958 10.6506 6.71854 9.49214 6.71854C8.33371 6.71854 7.39462 7.65958 7.39462 8.82041C7.39462 9.98124 8.33371 10.9223 9.49214 10.9223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverWhite);
export default __webpack_public_path__ + "static/media/discover-white.ece64318b39727b543dbee40a7236b82.svg";
export { ForwardRef as ReactComponent };